export enum GalleryTabsTypes {
  ALL = 'all',
  FAVORITES = 'favorites',
  BADGE_QUESTION = 'badge_question',
  BADGE_ANSWER = 'badge_answer',
}

export enum SubscriptionsPerRow {
  XL = 12,
  LG = 10,
  MD = 8,
  SM = 7,
  XS = 4,
}

export enum BubbleSizes {
  NORMAL = 88,
  LARGER = 132,
}
export interface GalleryTabs {
  icon?: string;
  name: string;
  type: GalleryTabsTypes;
  isSelected: boolean;
  isDeleteable: boolean;
  question?: string;
}
